import api from '../utils/api';

function unwrap(res) {
  const body = res?.data;
  if (body?.success === false) {
    const err = new Error(body.message || 'Request failed');
    err.status = res.status;
    throw err;
  }
  return body?.data ?? body;
}

export const adminGuideApi = {
  listAll: async () => {
    const res = await api.get('/admin-guide');
    return unwrap(res);
  },

  getModule: async (module) => {
    const res = await api.get(`/admin-guide/modules/${module}`);
    return unwrap(res);
  },

  getBySlug: async (slug) => {
    const res = await api.get(`/admin-guide/${slug}`);
    return unwrap(res);
  },

  getWorkflowSteps: async () => {
    const res = await api.get('/admin-guide/workflow/steps');
    return unwrap(res);
  },
};

export default adminGuideApi;
